import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Product } from "../types/Product";

interface WishlistState {
  items: Product[];
}

// Load wishlist from localStorage
const loadWishlistFromLocalStorage = (): Product[] => {
    try {
      const serializedProduct = localStorage.getItem('wishList');
      return serializedProduct ? JSON.parse(serializedProduct) : [];
    } catch (e) {
      console.error('Could not load wishlist from localStorage', e);
      return [];
    }
  };
// Save wishlist to localStorage whenever it changes
// const saveWishlistToLocalStorage = (id: Product) => {
//     try {
//       const serializedProduct = JSON.stringify(id);
//       localStorage.setItem('wishList', serializedProduct);
//     } catch (e) {
//       console.error('Could not save wishlist to localStorage', e);
//     }
//   };

const initialState: WishlistState = {
  items: loadWishlistFromLocalStorage(),
};

const wishlistSlice = createSlice({
  name: "wishList",
  initialState,
  reducers: {
    addToWishlist: (state, action: PayloadAction<Product>) => {
      if (!state.items.find((item) => item.id === action.payload.id)) {
        state.items.push(action.payload);
        localStorage.setItem("wishList", JSON.stringify(state.items));
      }
    },
    removeFromWishList: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
      localStorage.setItem("wishList", JSON.stringify(state.items));
    },
  },
});

export const { addToWishlist, removeFromWishList } = wishlistSlice.actions;
export default wishlistSlice.reducer;
